// Auto-generated normalizer for table: CAR_BOOKING.Vehiculo
export function vehiculoNormalize(row) {
  return {
    idVehiculo: row.idVehiculo ?? row.IdVehiculo ?? row['idVehiculo'] ?? 0,
    idTipoVehiculo: row.idTipoVehiculo ?? row.IdTipoVehiculo ?? row['idTipoVehiculo'] ?? 0,
    placa: row.placa ?? row.Placa ?? row['placa'] ?? '',
    economico: row.economico ?? row.Economico ?? row['economico'] ?? '',
    marca: row.marca ?? row.Marca ?? row['marca'] ?? '',
    modelo: row.modelo ?? row.Modelo ?? row['modelo'] ?? '',
    anio: row.anio ?? row.Anio ?? row['anio'] ?? 0,
    color: row.color ?? row.Color ?? row['color'] ?? '',
    capacidad: row.capacidad ?? row.Capacidad ?? row['capacidad'] ?? '',
    activo: row.activo ?? row.Activo ?? row['activo'] ?? false,
    fechaCreacion: row.fechaCreacion ?? row.FechaCreacion ?? row['fechaCreacion'] ?? null,
  };
}